import { useContext } from "react"
import appIcon from "../images/app_icon.jpg"
import "../styles/StockPrices.css"
import { StockPriceItem } from "./items/StockPriceItem"
import PlayerInfoContext from "../context/PlayerInfoContext"

export const StockPrices = ({ stockPrices, size }) => {
    const playerInfo = useContext(PlayerInfoContext);
    if (!stockPrices || stockPrices.error) return <div></div>
    return (
        <div className={`stock-price-container-${size}`}>
            <div style={{ display: "flex" }}>
                <img src={appIcon} alt="" style={{ width: `${size === "lg" ? "3vw" : "40px"}`, height: `${size === "lg" ? "3vw" : "40px"}`, borderRadius: `${size === "lg" ? "1.5vw" : "20px"}`, marginRight: "10px" }} />
                <div className={`stock-price-header`}>
                    {playerInfo?.chance ? "Select a company to trade" : playerInfo?.applyShareSuspend ? "Apply share suspend on a company" : "Company Prices"}
                </div>
            </div>
            <div style={{ display: `${size === "lg" ? "block" : "flex"}`, overflowX: `${size === "lg" ? "none" : "auto"}`, scrollbarWidth: "none", msOverflowStyle: "none" }}>
                {Object.entries(stockPrices).map(([company, value]) => {
                    return <StockPriceItem key={company} company={company} current={value.current} previous={value.previous} size={size} />
                })}
            </div>
            {size === "sm" && <p style={{ marginTop: "5px", marginBottom: "-5px", fontWeight: "bold", textAlign: "center", cursor:"pointer" }} onClick={()=>{window.location.href="/all-trades"}}>View all trades in this round</p>}
        </div>
    )
}